import { useSeasonStore } from '@/stores/useSeasonStore';

const env = import.meta.env.VITE_ENV;

const PORT_BACK_DARTSHUB: string = import.meta.env.VITE_PORT_BACK_DARTSHUB;
const PORT_FRONT_DARTSHUB: string = import.meta.env.VITE_PORT_FRONT_DARTSHUB;
const PORT_FRONT_COMPET: string = import.meta.env.VITE_PORT;
export const app_name: string = import.meta.env.VITE_APP_NAME;

export const backend_url =
    env === 'dev'
        ? `http://localhost:${PORT_BACK_DARTSHUB}`
        : `https://api.dartshub.fr`;

export const dartshub_url =
    env === 'dev'
        ? `http://localhost:${PORT_BACK_DARTSHUB}`
        : `https://api.dartshub.fr`;

export const auth_url =
    env === 'dev'
        ? `http://localhost:${PORT_FRONT_DARTSHUB}`
        : `https://auth.dartshub.fr`;

export const app_url =
    env === 'dev'
        // Compet tourne en HTTPS en dev (certificat auto-signé, cf. vite.config.ts,
        // requis par HelloAsso pour backUrl/returnUrl/errorUrl) -- si ce callback reste
        // en http://, le retour de connexion DartsHub ramène sur une origine différente
        // de celle qui a servi la page (CORS/cookies cassés après coup).
        ? `https://localhost:${PORT_FRONT_COMPET}`
        : `https://compet.dartshub.fr`;

// Source unique : la saison courante est calculée par Dartshub/backend (table `seasons`)
// et exposée via /seasons ; useSeasonStore() la met en cache côté client.
export const getCurrentSeason = (): string => useSeasonStore().currentSeason;

export const getSeasonFromDate = (dateStr: string) => {
    const d = new Date(dateStr);
    const year = d.getFullYear();
    const month = d.getMonth();
    if (month >= 7) {
        return `${year}-${year + 1}`;
    } else {
        return `${year - 1}-${year}`;
    }
};
